var path = '/app/vehicle-registrations/vehicle-registration.lookups.html';
var html = "<wor-table\n  [(data)]=\"lookups\"\n  (query)=\"getLookupsPage($event.params)\"\n  [settings]=\"tableSettings\">\n</wor-table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;